/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Col_ItemInputs */

const cs_ebr_col_item = /** @type {(inputs: Ebr_Col_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položka`)
};

const en_ebr_col_item = /** @type {(inputs: Ebr_Col_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

/**
* | output |
* | --- |
* | "Item" |
*
* @param {Ebr_Col_ItemInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_col_item = /** @type {((inputs?: Ebr_Col_ItemInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Col_ItemInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_col_item(inputs)
	return cs_ebr_col_item(inputs)
});